import { useEffect, useState } from "react";
import Lenis from "lenis";
import { Navbar } from "@/components/Navbar";
import { HeroSection } from "@/components/HeroSection";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { ServicePillars } from "@/components/ServicePillars";
import { CatalogueGrid } from "@/components/CatalogueGrid";
import { CompanyInfo } from "@/components/CompanyInfo";
import { Footer } from "@/components/Footer";
import { QuoteModal } from "@/components/QuoteModal";
import { ReservationModal } from "@/components/ReservationModal";

export default function HomePage() {
  const [quote, setQuote] = useState({ open: false, service: null, listing: null });
  const [reservation, setReservation] = useState({ open: false, listing: null });

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  const openQuote = (service = null, listing = null) => setQuote({ open: true, service, listing });

  return (
    <div className="bg-[#0D1117] min-h-screen" data-testid="home-page">
      <Navbar onQuote={() => openQuote()} />
      <HeroSection onQuote={() => openQuote()} />
      <EditorialMarquee />
      <ServicePillars onQuote={(service) => openQuote(service)} />
      <CatalogueGrid
        onQuote={(service, listing) => openQuote(service, listing)}
        onReserve={(listing) => setReservation({ open: true, listing })}
      />
      <CompanyInfo />
      <Footer />
      <QuoteModal
        open={quote.open}
        preset={{ service: quote.service, listing: quote.listing }}
        onClose={() => setQuote({ open: false, service: null, listing: null })}
      />
      <ReservationModal
        open={reservation.open}
        listing={reservation.listing}
        onClose={() => setReservation({ open: false, listing: null })}
      />
    </div>
  );
}
